import { type AnyRoute, createRouter } from '@tanstack/react-router';
import * as Sentry from '@sentry/react';

export function tanstack_router(routeTree: AnyRoute) {
	const router = createRouter({
		routeTree,
		scrollRestoration: true,
	});

	if (!router.isServer) {
		Sentry.init({
			dsn: import.meta.env.VITE_SENTRY_DSN,
			integrations: [
				Sentry.tanstackRouterBrowserTracingIntegration(router, { linkPreviousTrace: 'session-storage' }),
				Sentry.replayIntegration(),
				// Sentry.feedbackIntegration({
				// 	showBranding: false,
				// 	colorScheme: 'system',
				// 	triggerLabel: 'Feedback',
				// 	formTitle: 'Give Feedback',
				// 	submitButtonLabel: 'Submit Feedback',
				// }),
			],
			enableLogs: true,
			tracesSampleRate: 1.0,
			replaysSessionSampleRate: 1.0,
			replaysOnErrorSampleRate: 1.0,
		});
	}

	return router;
}
